import { NotFound } from "@dgs/core";
import { Navigate, Route, Routes } from "react-router";
import { EventOffboardingPage } from "../../../shared/events/offboarding/EventOffboardingPage";
import { UpdateEventTypePage } from "../../../shared/events/save/UpdateEventTypePage";
import { eventService } from "../shared/api/event/eventService";
import { EventDetailsPage } from "./eventDetails";
import { ArchivedEventDetailsPage } from "./eventDetails/ArchivedEventDetailsPage";
import { ArchivedEventList, EventList } from "./eventList";
import { UpdateEventPage } from "./UpdateEventPage";

export const ActiveEventPage = () => {
	return (
		<Routes>
			<Route index={true} element={<EventList />} />
			<Route path=":eventId">
				<Route index={true} element={<Navigate to="details" replace={true} />} />
				<Route path="*" element={<EventDetailsPage />} />
				<Route path="update">
					<Route path="*" element={<UpdateEventPage />} />
				</Route>
				<Route
					path="update-event-type/*"
					index
					element={<UpdateEventTypePage basePath="events/active" keysToInvalidate={[eventService.indexKey]} />}
				/>
				<Route path="offboarding">
					<Route index element={<Navigate to="key-metrics" replace={true} />} />
					<Route path="*" element={<EventOffboardingPage variant="elevated" />} />
				</Route>
			</Route>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};

export const ArchivedEventPage = () => {
	return (
		<Routes>
			<Route index={true} element={<ArchivedEventList />} />
			<Route path=":eventId">
				<Route index={true} element={<Navigate to="details" replace={true} />} />
				<Route path="*" element={<ArchivedEventDetailsPage />} />
			</Route>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
